function isEqualShallow(objA, objB) {
    if (!objA || !objB) {
        return false;
    }
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) {
        return false;
    }
    return keysA.every((key) => (key in objB && objA[key] === objB[key]));
}
export default isEqualShallow;
//# sourceMappingURL=is-equal-shallow.js.map